import { TaskSubTicketStatus } from 'dy-frontend-http-repository/lib/modules/TaskSubTicket/resources/TaskSubTicketResource';

import domain from './domain';

// Reset sub-tickets
export const resetSubTickets = domain.createEvent('resetSubTickets');

// Reset parent Request sub-ticket summary
export const resetSubTicketSummary = domain.createEvent('resetSubTicketSummary');

// Reset the parent Request's sub-task status transitions
export const resetSubTicketStatusLog = domain.createEvent('resetSubTicketStatusLog');

// Toggle archived sub-ticket visibility
export const setIsArchivedShown = domain.createEvent<boolean>('setIsArchivedShown');

// Toggle "Only mine"
export const setIsOnlyMineShown = domain.createEvent<boolean>('setIsOnlyMineShown');

// Status filter chips; an empty list means "no filter"
export const setStatusFilter = domain.createEvent<TaskSubTicketStatus[]>('setStatusFilter');

// Assigned-designer filter; ids, because a name is not an identity. An empty list means
// "no filter"
export const setDesignerFilter = domain.createEvent<ID[]>('setDesignerFilter');

// Inclusive due-date range in calendar days, either bound optional. Both bounds move together
// so an applied range can never be half-updated
export interface SubTicketDueDateRange {
    fromDate: string | null;
    toDate: string | null;
}

export const setDueDateRange = domain.createEvent<SubTicketDueDateRange>('setDueDateRange');

// Which sub-ticket is expanded into its detail panel, or null
export const setExpandedSubTicketId = domain.createEvent<ID | null>('setExpandedSubTicketId');
